module.exports = __webpack_public_path__ + "static/media/lenta_blue.e76b7c8b.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/media/forum/lenta_blue.svg
// module id = ./src/assets/media/forum/lenta_blue.svg
// module chunks = 16